import React from 'react'
import { connect } from 'react-redux'

import { search } from 'actions'
import { querySelector, availableSelector } from 'selectors'

import SearchField from './SearchField'

const Wrapper = ({ available, query, search, className }) => (
  <SearchField
    className={className}
    select={query => search({ query, available })}
    value={query}
  />
)

export default connect(
  state => ({
    query: querySelector(state) || '',
    available: availableSelector(state),
  }),
  { search }
)(Wrapper)



// WEBPACK FOOTER //
// ./src/components/Header/SearchField/index.js